import request from '../../utils/request'

const state = {}

const actions = {
    // 根据id获取实训的接口
    getTrainingInstanceSrc({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/training/${data}`,
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 创建实训实例
    postTrainingInstance({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/training/instance`,
                method: 'post',
                data
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 删除实训实例
    deleteTrainingInstance({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instance/${data}`,
                method: 'delete',
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取实训实例访问地址接口
    getTrainingInstance({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instance/${data}/access_address`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 停止实训实例
    putTrainingInstance({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instance/${data}`,
                method: 'put',
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 停止所有运行中实例
    stopAllTrainingInstance({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instance/running`,
                method: 'put',
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 获取实训实例文件列表
    getTrainingFileList({dispatch},data) {
        return new Promise((resolve)=>{
            let params = ""
            if (data.dirPath) {
                params = `?dir_path='${data.dirPath}'`
            }
            request({
                url: `/api/training/instance/${data.id}/file` + params,
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 获取实训实例环境中的文件的地址、文件名、请求头
    getTrainingFileDetail({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instance/${data.id}/file/reception`,
                // responseType:'blob',
                params: {
                    file_path: data.name
                }
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 下载实训实例环境中的文件
    async downloadTrainingFileList({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: data.url,
                headers: data.obj,
                responseType:'blob',
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 获取实训实例环境中上传文件的地址、请求头
    getTrainingUploadFileUrl({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instance/${data}/file`,
                method: 'post'
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 提交实训结果
    // postTrainingResult({dispatch},data) {
    //     return new Promise((resolve)=>{
    //         request({
    //             url: `/api/training/instances/${data.id}/command`,
    //             method: 'post',
    //             data
    //         }).then(data => {
    //             resolve(data);
    //         });
    //     })
    // },

    // 查看实训结果
    getTrainingResult({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instances/command/result`,
                method: 'post',
                data: JSON.stringify(data)
            }).then(data => {
                resolve(data);
            });
        })
    },

}

export default {
    state,
    actions
}
